import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const MobileNavbarSection = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="[&+&]:[border-top:1px_solid_#f1f1f1] [&+&]:mt-2.5 [&+&]:pt-3.5">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
MobileNavbarSection.propTypes = {
  children: PropTypes.node
};
export default MobileNavbarSection;